import Switch, { SwitchProps } from 'antd/es/switch';
import classNames from 'classnames';
import styles from './Switch.module.css';

export interface CustomSwitchProps extends SwitchProps {
  label?: string;
  subLabel?: string;
  classNameContainer?: string;
  classNameSubLabel?: string;
  variant?: 'blue' | 'black';
}

export const CustomSwitch = ({
  label,
  subLabel,
  classNameSubLabel,
  classNameContainer,
  variant = 'blue',
  ...props
}: CustomSwitchProps) => {
  return (
    <div className={classNames(styles.switchScope, 'flex gap-3', classNameContainer)}>
      <Switch
        {...props}
        rootClassName={variant === 'black' ? 'my-custom-switch-black' : undefined}
        className={classNames('mt-1', props?.className)}
      />
      {label && (
        <span className="flex flex-col justify-center items-start font-[Inter]">
          <label
            className={classNames(
              {
                'text-gray-900 text-[18px]': !props?.className?.includes('text-'),
                'leading-[20px]': !props?.className?.includes('leading-'),
              },
              props?.className,
            )}
          >
            {label}
          </label>
          {subLabel && (
            <label
              className={classNames(
                {
                  'text-gray-600 text-[12px]': !classNameSubLabel?.includes('text-'),
                  'leading-[20px]': !classNameSubLabel?.includes('leading-'),
                },
                classNameSubLabel,
              )}
            >
              {subLabel}
            </label>
          )}
        </span>
      )}
    </div>
  );
};
